import React from "react";
import { siteMap } from "internal-sitemap";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { useHistory } from "react-router";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import { t } from "utilities/localization-utils";

const BASE_CLASS = "c-authorized-header";

const AuthorizedHeader = () => {
    const history = useHistory();

    return (
        <header className={BASE_CLASS}>
            <Button
                style={ButtonStyles.Tertiary}
                cssClassName={`${BASE_CLASS}__iconButton`}
                onClick={() => {
                    history.push(siteMap.dashboards.user);
                }}>
                <Icon type={Icons.ChevronLeft} /> {t("backToDashboard")}
            </Button>
        </header>
    );
};

export default AuthorizedHeader;
